import script from "./ChoicePart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChoicePart.vue?vue&type=script&lang=ts&setup=true"

import "./ChoicePart.vue?vue&type=style&index=0&id=67361c8d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67361c8d"]])

export default __exports__